import { render, staticRenderFns } from "./goodsInfoNotice.vue?vue&type=template&id=090547c1&scoped=true&"
import script from "./goodsInfoNotice.vue?vue&type=script&lang=js&"
export * from "./goodsInfoNotice.vue?vue&type=script&lang=js&"
import style0 from "./goodsInfoNotice.vue?vue&type=style&index=0&id=090547c1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090547c1",
  null
  
)

export default component.exports